// ── Split "[marker]" tokens from marked-text string ──────────────────────────
// Kept in a module of its own, free of the Supabase client, so the pure
// annotation code (and its tests) can read marked text the same way the
// renderers do.
export function parseMarkerParts(text) {
  const parts = [];
  const re = /\[([^\]]+)\]/g;
  let lastIdx = 0, m;
  while ((m = re.exec(text))) {
    if (m.index > lastIdx) parts.push({ kind: 'text', text: text.slice(lastIdx, m.index) });
    parts.push({ kind: 'marker', marker: m[1] });
    lastIdx = m.index + m[0].length;
  }
  if (lastIdx < text.length) parts.push({ kind: 'text', text: text.slice(lastIdx) });
  return parts;
}
